module.exports = __webpack_public_path__ + "img/stats.02f00c49.svg";